<template>
  <v-select
    @change="$emit('event-changed', $event)"
    outlined
    dense
    hide-details
    clearable
    :rules="requiredRule"
    label="Event type"
    :items="calendarEvents"
    item-value="node.valName"
    item-text="node.valName"
  ></v-select>
</template>
<script>
import { validation } from "../../mixins/validationMixin";

export default {
  mixins: [validation],
  computed: {
    calendarEvents() {
      if (this.$store.getters.categoryValue.edges) {
        return this.$store.getters.categoryValue.edges.filter(
          c => c.node.category.catName === "CALENDAR_EVENTS"
        );
      } else {
        return [];
      }
    }
  }
};
</script>
